import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { newsAPI } from "../../services/api";
import NewsItem from "../../components/News/NewsItem";
import NewsFull from "../../components/News/NewsFull";

const NewsPage = () => {
  const { t, i18n } = useTranslation("news");
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNews, setSelectedNews] = useState(null); // выбранная новость

  useEffect(() => {
    const getNewsLang = (lang) => {
      switch (lang) {
        case "uz":
          return 'UZB'

        case "en":
          return 'ENG'

        default:
        case "ru":
          return 'RUS'
      }
    }
    const fetchNews = async () => {
      try {
        setLoading(true);
        const response = await newsAPI.getNews(0, 100, getNewsLang(i18n.language));
        const data = response?.data?.result?.data?.items || [];
        setNews(data);
      } catch (err) {
        console.error("Ошибка при загрузке новостей:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [i18n.language]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-60">
        <span className="text-gray-500">{t("LOADING") || "Загрузка..."}</span>
      </div>
    );
  }

  if (selectedNews) {
    return (
      <NewsFull
        item={selectedNews}
        onBack={() => setSelectedNews(null)}
      />
    );
  }

  if (news.length === 0) {
    return (
      <div className="bg-white rounded-xl p-10 text-center shadow-md animate-fadeIn">
        <div className="flex flex-col items-center gap-3">
          <span className="text-5xl opacity-50">📝</span>
          <h3 className="text-lg font-semibold text-gray-800">
            {t("NEWS_IS_EMPTY") || "Новостей нет"}
          </h3>
          <p className="text-sm text-gray-400">
            {t("YOUR_NEWS_WILL_APPEAR_HERE") || "Ваши новости появятся здесь"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <article className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
      {news.map((item) => (
        <NewsItem key={item.uuid} item={item} onClick={() => setSelectedNews(item)} />
      ))}
    </article>
  );
};

export default NewsPage;
